import * as React from "react";
import { SelectFieldSchema, LoadState, useGetDatasourceOptions } from "@cak-legacy/generation-core";
import { ThreeDots } from "@cak-legacy/shared-common";
import { getValueFromObject, useDataContext } from "@cak-legacy/generation-overview-core";
import { withHideOnFieldHoc } from "../Hoc/withHideOnFieldHoc";
import { withRenderFieldHoc } from "../Hoc/withRenderFieldHoc";
import { ItemValue } from "../Components/ItemValue";

import "./ReadItem.scss";
import { useReadContainerPropsContext } from "../Context/Read/ReadContainerPropsContextProvider";

export interface SelectFieldProps {
  name: string;
  field: SelectFieldSchema;
}

export const SelectField = withHideOnFieldHoc(
  withRenderFieldHoc((props: SelectFieldProps): JSX.Element => {
    const readContainerProps = useReadContainerPropsContext();
    const persoonContext = useDataContext();

    const { options, loadState } = readContainerProps?.fieldDefaults?.select
      ?.usesDatasourcesOrOptionsInOverview
      ? useGetDatasourceOptions({
          field: props.field,
          name: props.name,
          getValue: (key: string) => getValueFromObject(persoonContext, key)
        })
      : { options: null, loadState: LoadState.loaded };

    const value = getValueFromObject(persoonContext, props.name);
    const [presentationValue, setPresentationValue] = React.useState<string | null>(null);

    React.useEffect(() => {
      if (
        value &&
        readContainerProps?.fieldDefaults?.select?.usesDatasourcesOrOptionsInOverview &&
        options &&
        options.length > 0
      ) {
        const labelValue = options.find((item) => item.value === value)?.label ?? undefined;

        setPresentationValue(
          props.field.formatSelectedLabelValue
            ? props.field.formatSelectedLabelValue(labelValue ?? "") ?? ""
            : labelValue ?? ""
        );
      }
    }, [value, options]);

    if (loadState === LoadState.loading) {
      return <ThreeDots loading={true} />;
    }

    const { overview } = props.field;

    const renderableValue = readContainerProps?.fieldDefaults?.select?.usesDatasourcesOrOptionsInOverview
      ? presentationValue
      : value;

    const valueHelper = overview?.formatValue?.(renderableValue) ?? renderableValue;

    return <ItemValue value={overview?.render?.(valueHelper) ?? valueHelper} />;
  })
);
